import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { API, unwrap } from "./projetsCommon";

/**
 * Liste déroulante « Projet (facultatif) » à placer dans les formulaires d'achat / de vente.
 *
 *   <ProjetSelect value={formik.values.projetId} onChange={(v) => formik.setFieldValue("projetId", v)} clientId={formik.values.clientId} />
 *
 * value / onChange : id du projet ou "" (aucun).
 * clientId (optionnel) : côté vente, les projets de ce client sont proposés en premier.
 */
const ProjetSelect = ({ value, onChange, clientId, label = "Projet (facultatif)", disabled }) => {
    const [projets, setProjets] = useState([]);

    useEffect(() => {
        axiosInstance.get(API.projetOptions)
            .then((res) => setProjets(unwrap(res) || []))
            .catch(() => setProjets([]));
    }, []);

    const duClient = clientId ? projets.filter((p) => String(p.clientId) === String(clientId)) : [];
    const autres = clientId ? projets.filter((p) => String(p.clientId) !== String(clientId)) : projets;

    // Projet déjà choisi mais devenu terminé/annulé : on le garde affiché
    const inconnu = value && !projets.some((p) => String(p.id) === String(value));

    return (
        <>
            {label && <label>{label}</label>}
            <select className="form-control" value={value ?? ""} disabled={disabled}
                onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}>
                <option value="">— Aucun (opération courante) —</option>
                {inconnu && <option value={value}>Projet n° {value} (clôturé)</option>}
                {duClient.length > 0 && (
                    <optgroup label="Projets du client">
                        {duClient.map((p) => <option key={p.id} value={p.id}>{p.libelle}</option>)}
                    </optgroup>
                )}
                {duClient.length > 0 ? (
                    <optgroup label="Autres projets">
                        {autres.map((p) => <option key={p.id} value={p.id}>{p.libelle}</option>)}
                    </optgroup>
                ) : autres.map((p) => <option key={p.id} value={p.id}>{p.libelle}</option>)}
            </select>
        </>
    );
};

export default ProjetSelect;
